import React from 'react';
import {NavLink} from 'react-router-dom';
import styles from './HeaderNav.module.css';

function HeaderNav({ url, children, disableActive }) {
    return (
        <NavLink 
            to={url} 
            className={({ isActive }) => 
                (isActive && !disableActive) ? `${styles.link} ${styles.active}` : styles.link
            }
        >
            {children}
        </NavLink>
    );
}

export default HeaderNav;